import { Report } from 'types'

export interface NotifyAsyncExportStartedOptions {
    reportName: string
    /** API response body (`response.data`, saga payload, etc.) or a `Report`. */
    report?: unknown
    description?: string
}

export function reportFromExportData(data: unknown): Report | null {
    if (data == null || typeof data !== 'object') {
        return null
    }

    if (!('id' in data)) {
        return null
    }

    const { id } = data
    if (typeof id !== 'string' || id === '') {
        return null
    }

    return data as Report
}
